export function CustomIASCell({
  cell: {
    row: { original: rowData }
  }
}: Record<string, any>) {
  const { id, name, targeting } = rowData;
  const icon = targeting === 'avoidance' ? 'minus' : 'plus';
  return (
    <div className={`customIasCell customIasCell--${targeting}`} key={`iasCategory-${id}`} title={name}>
      <span className="customIasCell__icon fa-stack">
        <span className="fas fa-circle fa-stack-1x customIasCell__iconBase" />
        <span className={`fa-stack-1x customIasCell__iconValue fa-solid fa-${icon}`} />
      </span>
      <div className="customIasCell__content">
        <span className="customIasCell__name">{name}</span>
        <span className="customIasCell__id">{`ID: ${id}`}</span>
      </div>
    </div>
  );
}
